import { render, staticRenderFns } from "./AxSorter.vue?vue&type=template&id=2b2615e4&functional=true&"
import script from "./AxSorter.vue?vue&type=script&lang=ts&"
export * from "./AxSorter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports